// Machine trailers are not member-facing text, including when a tool's
// narration follows them. Keep literal protocol examples inside Markdown
// code spans/fences. Streaming may stop halfway through a marker or fence.
export const stripAnswerTrailers = (text, opts) => {
  const input = text == null ? '' : String(text)
  const names = ['SUGGEST:', 'SOURCES:', 'CONFIDENCE:', 'LEVEL:']
  let out = ''
  let i = 0
  while (i < input.length) {
    if (i === 0 || input[i - 1] === '\n') {
      const fence = /^ {0,3}(`{3,}|~{3,})[^\n]*(?:\n|$)/.exec(input.slice(i))
      if (fence) {
        const mark = fence[1]
        const close = new RegExp('^ {0,3}' + mark[0] + '{' + mark.length + ',}[ \\t]*\\r?$', 'gm')
        close.lastIndex = i + fence[0].length
        const end = close.exec(input)
        const next = end ? end.index + end[0].length : input.length
        out += input.slice(i, next)
        i = next
        continue
      }
    }
    if (input[i] === '`') {
      const mark = /^`+/.exec(input.slice(i))[0]
      const close = /`+/g
      close.lastIndex = i + mark.length
      let end
      for (let match = close.exec(input); match; match = close.exec(input)) {
        if (match[0].length === mark.length) {
          end = match.index + mark.length
          break
        }
      }
      const next = end || i + mark.length
      out += input.slice(i, next)
      i = next
      continue
    }
    if (input[i] === '<') {
      const tail = input.slice(i)
      if (/^<!--[ ]{0,3}(?:SUGGEST|SOURCES|CONFIDENCE|LEVEL):/.test(tail)) {
        const close = input.indexOf('-->', i + 4)
        i = close < 0 ? input.length : close + 3
        continue
      }
      if (opts && opts.partial) {
        const cut = /^<(?:!(?:-(?:-([ ]{0,3})([A-Z]*))?)?)?$/.exec(tail)
        if (cut && (!cut[2] || names.some((name) => name.startsWith(cut[2])))) break
      }
    }
    out += input[i++]
  }
  return out === input ? out : out.replace(/\s+$/, '')
}
